
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import { NavBar } from './components/nav-bar';
import { ShippById } from './pages/shipp-by-id';
import { ListShipps } from './pages/shipps-list';
import { SignUp ,SignIn, AddCaptin} from './pages/auth';
import { CreateShipp, EditShipp, UpdateShipp } from './pages/shipp-operations';
import { CurrentUserContextProvider } from './components/user-context';
import { Home } from './pages/home';
import {SplitScreen} from './pages/landing';
import { SearchShipp } from './pages/search-shipp';
import { AdminControl } from './pages/admin-control';
import { ListCaptins } from './pages/list-captins';
import { ControlUser } from './pages/control-user';
import { UserProfile } from './pages/user-profile';
import ScrollToTop from "./components/scrolltop";
import { ForgotPasswordForm } from './components/forgot-password';
import { ResetPasswordForm } from './components/reset-password';
export const App=() => {
  
  return (
    <>
    <CurrentUserContextProvider>
    <BrowserRouter>
    
    <NavBar />
   <ScrollToTop/>
      <Routes>
      
        <Route path='/' element={<SplitScreen />}/>
        <Route path='/home' element={<Home />}/>
        <Route path='/shipp' element={<SearchShipp />}/>
        <Route path='/shipp/:id' element={<ShippById />}/>
        <Route path='/shipps/:state' element={<ListShipps />}/>
        <Route path='/signup' element={<SignUp />}/>
        <Route path='/signin' element={<SignIn />}/>
        <Route path='/newshipp' element={<CreateShipp />}/>
        <Route path='/editshipp' element={<EditShipp />}/>
        <Route path='/updateshipp/:id' element={<UpdateShipp />}/>
        <Route path='/addcaptin' element={<AddCaptin />}/>     
        <Route path='/admincontrol' element={<AdminControl />}/>    
        <Route path='/controluser' element={<ControlUser />}/>  
        <Route path='/listcaptins' element={<ListCaptins />}/>  
        <Route path='/userprofile' element={<UserProfile />}/>   
        <Route path='/forgotpass' element={<ForgotPasswordForm />}/>  
        <Route path='/resetpass/:token' element={<ResetPasswordForm />}/>  
         
      </Routes>
    </BrowserRouter>
    </CurrentUserContextProvider>
    </>
    
  );
};

